import React, { createRef, Fragment, useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import { Button, Divider, ExpandCollapse, Typography } from '@telus-uds/components-web';
import palette from '@telus-uds/palette-allium/build/web/palette';
import _ from 'lodash';

import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import {
  getMultiCheckboxOptions,
  findField,
  getFieldName,
  getFieldValue,
  getFieldType,
  getFieldChecked
} from './utils/formCommon';
import StatusBar from '../iot/statusBar';
import { Box } from '../design/css';
import {
  GroupTitle,
  GroupWrapper,
  GroupWrapperStyled,
  SectionHeaderTitle,
  SummaryGroupWrapper
} from './css';
import {
  iotPrequalificationForm,
  iotOrderForm,
  fieldIotAccountType,
  fieldIotCorporateType,
  fieldIotNewOrExisting,
  fieldIotAccessAccountViaSmartDesktop,
  fieldIotCreditCheckPassInCarat,
  fieldIotAddonSpecificSubscriber,
  fieldIotAddonSubscriberList,
  fieldIotVehicleOptions,
  fieldIotAdditionalAttachements,
  fieldIotAdditionalComment,
  fieldIotTelusAccountNumber,
  fieldIotActivationOrRenwal,
  fieldIotProductSelected,
  fieldCaratCreditCheckFailMessage,
  fieldIotIncorporationNumber,
  fieldIotIncorporationDate,
  fieldIotSubscribersRenewalOptions,
  fieldIotCaratCaseId,
  fieldIotManagersEmailApproval,
  fieldIotDeliveryOptions,
  fieldIotCustomerRequireProInstallService,
  fieldIotPromoAvailable,
  fieldCustomerMigrating,
  fieldMobilityAccountNote,
  fieldIotFillipFleetIdCheck,
  unitLimitForprofessionalServices,
  unitLimitForprofessionalServicesColdChain
} from '../utils/constant';
import useFetchContentfulData from '../hooks/useFetchContentfulData';
import {
  getRateplanData,
  getHardwareData,
  getTechnicalServicesData,
  getFarmAndRanchTankDetails,
  getDataOfAccessories,
  showByodOnActivation
} from './formStepIoTUtils';

import UserDetailsForm from './userDetailsForm';
import Note from '../note';
import FormSummaryGroup from './formSummaryGroup';
import RepeatedForm from './repeatedForm';
import stringInterpolation from '../utils/stringInterpolation';
import FormField from './formField';
import ViewsToggle from '../iot/orderDetailsSection/viewsToggle';
import RatePlans from '../iot/orderDetailsSection/ratePlans';
import GeotabBundles from '../iot/orderDetailsSection/geotabBundles';
import Addons from '../iot/orderDetailsSection/addonSection';
import AdditionalServices from '../iot/orderDetailsSection/additionalServices';
import Hardware from '../iot/orderDetailsSection/hardware';
import HardwarePowerfleet from '../iot/orderDetailsSection/hardwarePowerFleet';
import VehicleInfo from '../iot/orderDetailsSection/vehicleInfo';
import TankDetails from '../iot/orderDetailsSection/tankdetails';
import SummaryTracker from '../iot/summaryTracker';
import RatePlansRenewal from '../iot/orderDetailsSection/ratePlansRenewal';
import DeliveryCharges from '../iot/orderDetailsSection/deliveryCharges';
import TechnicalServices from '../iot/orderDetailsSection/technicalServices';
import InstallServices from '../iot/orderDetailsSection/installServices';
import TankDetailsFarmAndRanch from '../iot/orderDetailsSection/tankdetailsFarmAndRanch';
import SummaryTrackerPowerFleet from '../iot/summaryTracker/powerFleetTracker';
import InstallServicesGeotab from '../iot/orderDetailsSection/installServicesGeotab';
import OrderNow from '../iot/orderDetailsSection/orderNow';
import {
  getEffectiveAccountType,
  isCustomPricingCorporate as checkCustomPricingCorporate
} from '../utils/corporatePricing';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const requiredValue = 'required';
const profile = request.getProfile();

const FormStepIoT = ({
  stepData,
  setEligible = null,
  onSaveAndExit = null,
  orderData = {},
  setOrderData = () => {},
  formName,
  createNewIotOrder,
  onFormSubmit
}) => {
  if (!stepData) return null;

  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: {
      yes,
      no,
      valueNew,
      valueExisting,
      valueBusinessRegularMedium,
      valueBusinessRegularSmall,
      valueBusinessPersonal,
      valueBusinessRegular,
      valueCorporate,
      valueCorporateStandardPricing,
      value2year,
      value3year,
      valueRenewal,
      valueGeotab,
      valueFleetcomplete,
      valueRaven,
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch,
      valueFillipFleet,
      valuePowerFleet,
      valueGeoforce,
      valueNewDeviceDbWaiver80,
      valueEnterListManually,
      valueEnterTankDetailsManually,
      valueStandardShipping,
      valueExpeditedShipping
    },
    modalForm: { fieldRequiredMessage, cannotProceedMessage },
    formStep: {
      minValueErrorMessage,
      maxValueErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage
    },
    formButtons: { newOrderButtonLabel, submittingButtonLabel },
    iotOrderDetailsSection: {
      labelFieldCustomerMigrationFC,
      errorMessageViewType,
      errorMessageRatePlan,
      errorMessageRenewal,
      errorMessageTankDetails,
      errorMessageTechnicalServices
    }
  } = localizedStrings;
  const {
    fields: { name: formStepName, formStepFields, formSummary, modalForms }
  } = stepData;

  const [isLoading, setIsLoading] = useState(true);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormValidated, setIsFormValidated] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [dueMonthly, setDueMonthly] = useState(0);
  const [isFieldReset, setIsFieldReset] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [prequalEligibility, setPrequalEligibility] = useState(false);
  const [viewType, setViewType] = useState();
  const [ratePlans, setRatePlans] = useState({});
  const [renewalSubscriberList, setRenewalSubscriberList] = useState([]);
  const [geotabBundles, setGeotabBundles] = useState({});
  const [addons, setAddons] = useState({});
  const [additionalServices, setAdditionalServices] = useState({});
  const [hardware, setHardware] = useState({});
  const [
    monthlySoftwareSubscription,
    setMonthlySoftwareSubscription
  ] = useState({});
  const [hardwarePowerFleet, setHardwarePowerFleet] = useState({});
  const [professionalServices, setProfessionalServices] = useState({});
  const [
    hardwareColdChainPowerFleet,
    setHardwareColdChainPowerFleet
  ] = useState({});
  const [
    professionalServicesColdChain,
    setProfessionalServicesColdChain
  ] = useState({});
  const [installServices, setInstallServices] = useState({});
  const [orderNow, setOrderNow] = useState({});
  const [technicalServices, setTechnicalServices] = useState({});
  const [vehicleInfo, setVehicleInfo] = useState([]);
  const [tankDetails, setTankDetails] = useState([]);
  const [geoTabNewPriceValid, setGeoTabNewPriceValid] = useState(false);
  const [tankDetailsFarmAndRanch, setTankDetailsFarmAndRanch] = useState({
    fuelGauge: [],
    fuelPressure: [],
    propane: []
  });
  const [total, setTotal] = useState({
    ratePlan: 0,
    subscriberList: 0,
    geotabBundles: 0,
    addons: 0,
    addonsMonthly: 0,
    addonsDueNow: 0,
    additionalServices: 0,
    hardware: 0,
    accessories: 0,
    installServices: 0,
    deliveryCharges: 0,
    technicalServices: 0,
    shippingCharges: 0,
    monthlySoftwareSubscription: 0,
    hardwarePowerFleet: 0,
    professionalServices: 0,
    hardwareColdChainPowerFleet: 0,
    professionalServicesColdChain: 0,
    orderNow: 0,
    ratePlanOneTime: 0,
    iotPopup: {}
  });
  const userProfile = request.getProfile();
  const { channels } = userProfile;
  const userChannel = channels && channels.length > 0 ? channels[0] : {};
  const { name: userChannelName } = userChannel;
  const compatibleChannels = ['Fleet Complete'];
  const isChannelFleetCompleteCompatible = compatibleChannels.includes(
    userChannelName
  );

  const viewTypeRef = useRef();

  const valueProductSelected = _.get(orderData, fieldIotProductSelected, '');

  const iotOrderDetailsKeyMap = {
    [valueGeotab]: 'ioTGeoTabOrderDetails',
    [valueFleetcomplete]: 'ioTFleetCompleteOrderDetails',
    [valueRaven]: 'ioTRavenOrderDetails',
    [valueNorthStarSystems]: 'ioTNorthStarSystemsOrderDetails',
    [valueNorthStarSystemsFarmAndRanch]:
      'ioTNorthStarSystemsFarmNRanchOrderDetails',
    [valueFillipFleet]: 'ioTNorthStarSystemsFarmNRanchOrderDetails',
    [valuePowerFleet]: 'ioTFleetCompleteOrderDetails',
    [valueGeoforce]: 'ioTGeoforceOrderDetails'
  };

  const getIotOrderDetilsKey = () =>
    _.get(iotOrderDetailsKeyMap, valueProductSelected, 'ioTGeoTabOrderDetails');

  const { data: contentfulData, error: contentfulError } =
    orderData && useFetchContentfulData(getIotOrderDetilsKey());

  const formStepRef = createRef();

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;

    return id === formSection;
  });

  const [openPanels, setOpenPanels] = useState(() => {
    // Calculate initial open panels on first render
    return sections.reduce((acc, section) => {
      const {
        fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
      } = section;

      if (isPanelInitiallyOpen) {
        acc.push(name);
      } else {
        const isErrors =
          sectionFields &&
          sectionFields.find(item => {
            const {
              fields: { name: itemName }
            } = item;
            return formErrors[itemName];
          });
        if (typeof isErrors !== 'undefined') acc.push(name);
      }

      return acc;
    }, []);
  });

  useEffect(() => {
    // Recalculate when formErrors change (for validation errors)
    const open = sections.reduce((acc, section) => {
      const {
        fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
      } = section;

      if (isPanelInitiallyOpen) {
        acc.push(name);
      } else {
        const isErrors =
          sectionFields &&
          sectionFields.find(item => {
            const {
              fields: { name: itemName }
            } = item;
            return formErrors[itemName];
          });
        if (typeof isErrors !== 'undefined') acc.push(name);
      }

      return acc;
    }, []);
    
    setOpenPanels(open);
  }, [formErrors]);

  const getDefaultValue = (key, value) => {
    if (orderData && orderData.id) return orderData[key];
    return value || '';
  };

  const normalizedFields = (data, initFields) => {
    let result = initFields;
    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          customFieldErrorMessage,
          resetFields,
          customResetFields
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();

        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result);
        } else if (id === formSection) {
          result = normalizedFields(fields.formFields, result);
        } else if (id === userDetailsKey) {
          /**
           * For All IoT Products
           * 1. Remove the Same as Service/Shipping Address checkbox from Billing address
           * 2. Rename Same as Service/Shipping Address checkbox to Same as Billing Address for Delivery Address section
           */
          const fieldKey = _.get(fields, 'backendKey', '');
          if (fieldKey === 'billingAddress') delete fields.sameAsCheckBox;
          if (fieldKey === 'deliveryAddress') {
            fields.dependsOnBackendField = 'billingAddress';
            fields.sameAsCheckBox.fields.label = 'Sames as Billing Address';
          }
          result = normalizedFields(fields.formStepFields, result);
        } else if (id === repeatedFormKey) {
          const formObjectKeys = fields.formFields.reduce(
            (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
              acc[formNameKey] = defaultValue;
              return acc;
            },
            {}
          );
          result[fields.key] = [formObjectKeys];
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          const defaultValue = getDefaultValue(key, value);
          let updatedMonthlyPayment = monthlyPayment;
          let updatedPrice = price;

          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );

              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
              }
            }
          }

          if (type === 'MultiCheckbox') {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
            }
          }

          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField,
            customFieldErrorMessage
          };

          if (resetFields) {
            result[key].resetFields = resetFields;
          }

          if (customResetFields) {
            result[key].customResetFields = customResetFields;
          }

          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }

          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
      });
    }

    return result;
  };

  const isManagersEmailApprovalRequired = () =>
    renewalSubscriberList.some(
      subscriber => subscriber.offer === valueNewDeviceDbWaiver80
    );

  const customChecks = (fieldName, fields) => {
    /**
     * Corporate - Standard Pricing must follow the same form flow as
     * Business Regular Medium. Treat Standard-Pricing Corporate as BRM
     * for all BRM-dependent field visibility/gating below. Custom-Pricing
     * Corporate (and legacy Corporate orders without iotCorporateType)
     * keep the existing Corporate flow.
     *
     * Read iotCorporateType from the passed `fields` (not the
     * `formFields` state closure) so that an in-flight Standard <-> Custom
     * toggle — where handleFormField mutates a copy of formFields before
     * react commits the new state — sees the just-updated pricing type
     * and not a stale one. All other reads keep the original formFields
     * source to avoid any behavioural change outside this narrow case.
     */
    const valueAccountType = getEffectiveAccountType(
      getFieldValue(fieldIotAccountType, formFields),
      getFieldValue(fieldIotCorporateType, fields),
      {
        valueCorporate,
        valueCorporateStandardPricing,
        valueBusinessRegularMedium
      }
    );
    const valueNewOrExisting = getFieldValue(fieldIotNewOrExisting, formFields);
    const valueAccountAccessViaSmartDesktop = getFieldValue(
      fieldIotAccessAccountViaSmartDesktop,
      fields
    );
    const valueCreditCheckPass = getFieldValue(
      fieldIotCreditCheckPassInCarat,
      formFields
    );

    if (
      fieldName === fieldMobilityAccountNote &&
      (valueProductSelected === valueNorthStarSystemsFarmAndRanch ||
        valueProductSelected === valueFillipFleet) &&
      valueNewOrExisting !== valueExisting
    )
      return false;

    /**
     * Delivery Option
     */
    if (
      fieldName === fieldIotDeliveryOptions &&
      [valueNorthStarSystems, valueNorthStarSystemsFarmAndRanch].includes(
        valueProductSelected
      )
    )
      return false;

    /**
     * Managers Email Approval
     */
    if (
      fieldName === fieldIotManagersEmailApproval &&
      !isManagersEmailApprovalRequired()
    )
      return false;

    /**
     * Customer Migrating
     */
    if (
      fieldName === fieldCustomerMigrating &&
      [
        valueRaven,
        valueNorthStarSystems,
        valueNorthStarSystemsFarmAndRanch,
        valueFillipFleet,
        valuePowerFleet,
        valueGeoforce
      ].includes(valueProductSelected)
    )
      return false;

    /**
     * Credit check pass in CARAT
     */
    if (
      fieldName === fieldIotCreditCheckPassInCarat &&
      !(
        ([valueBusinessRegularSmall, valueBusinessRegularMedium].includes(
          valueAccountType
        ) &&
          valueNewOrExisting &&
          valueAccountAccessViaSmartDesktop === yes) ||
        valueProductSelected === valueRaven
      )
    )
      return false;

    if (
      ([
        fieldIotAddonSpecificSubscriber,
        fieldIotAddonSubscriberList,
        fieldIotVehicleOptions,
        fieldIotAdditionalAttachements,
        fieldIotAdditionalComment,
        fieldIotPromoAvailable,
        fieldIotCustomerRequireProInstallService
      ].includes(fieldName) &&
        !viewType) ||
      ([fieldIotAddonSpecificSubscriber, fieldIotAddonSubscriberList].includes(
        fieldName
      ) &&
        viewType !== 'advancedView')
    )
      return false;

    /**
     * CARAT/CAR Error Message
     */
    if (
      fieldName === fieldCaratCreditCheckFailMessage &&
      valueProductSelected === valueNorthStarSystemsFarmAndRanch &&
      valueNewOrExisting === valueExisting &&
      valueAccountAccessViaSmartDesktop === no
    )
      return true;

    if (fieldName === fieldCaratCreditCheckFailMessage) {
      if (
        !(
          ([
            valueGeotab,
            valueFleetcomplete,
            valueNorthStarSystems,
            valueNorthStarSystemsFarmAndRanch,
            valueFillipFleet,
            valuePowerFleet,
            valueGeoforce
          ].includes(valueProductSelected) &&
            [valueBusinessRegularSmall, valueBusinessRegularMedium].includes(
              valueAccountType
            ) &&
            valueCreditCheckPass === no) ||
          (valueProductSelected === valueRaven && valueCreditCheckPass === no)
        )
      )
        return false;

      if (
        valueProductSelected === valueNorthStarSystemsFarmAndRanch &&
        valueAccountAccessViaSmartDesktop === no
      )
        return false;
    }

    /**
     * Incorporation Number
     * Incorporation Date
     */
    if (
      [fieldIotIncorporationNumber, fieldIotIncorporationDate].includes(
        fieldName
      ) &&
      !(
        [
          valueGeotab,
          valueFleetcomplete,
          valueNorthStarSystems,
          valueNorthStarSystemsFarmAndRanch,
          valueRaven,
          valueFillipFleet,
          valuePowerFleet,
          valueGeoforce
        ].includes(valueProductSelected) &&
        valueNewOrExisting === valueNew &&
        valueAccountAccessViaSmartDesktop === no
      )
    )
      return false;

    /**
     * CARAT/CAR Case ID
     */
    if (
      fieldName === fieldIotCaratCaseId &&
      !(
        ([
          valueGeotab,
          valueFleetcomplete,
          valueNorthStarSystems,
          valueNorthStarSystemsFarmAndRanch,
          valueRaven,
          valueFillipFleet,
          valuePowerFleet
        ].includes(valueProductSelected) &&
          [
            valueBusinessRegularSmall,
            valueBusinessRegularMedium,
            valueBusinessPersonal,
            valueBusinessRegular
          ].includes(valueAccountType) &&
          ((valueAccountAccessViaSmartDesktop === yes &&
            valueCreditCheckPass === yes) ||
            valueAccountAccessViaSmartDesktop === no)) ||
        valueCreditCheckPass === yes
      )
    )
      return false;

    /**
     * Telus Account Number
     */
    if (
      fieldName === fieldIotTelusAccountNumber &&
      !(
        ([valueBusinessRegularSmall, valueBusinessRegularMedium].includes(
          valueAccountType
        ) ||
          valueProductSelected === valueRaven) &&
        ((valueAccountAccessViaSmartDesktop === yes &&
          valueCreditCheckPass === yes) ||
          valueAccountAccessViaSmartDesktop === no)
      ) &&
      !(
        valueNewOrExisting === valueExisting &&
        valueAccountAccessViaSmartDesktop === no
      )
    )
      return false;

    if (fieldName === fieldIotSubscribersRenewalOptions && !viewType)
      return false;

    // if (fieldName === 'iotTechnicalServices' && viewType === 'simpleView')
    //   return false;

    return true;
  };

  const isRelatedFieldExisted = (field, fields) => {
    const {
      name: fieldName,
      appearsAfterField,
      appearsAfterValue,
      backendFieldValidation
    } = field;

    const passCustomChecks = customChecks(fieldName, fields);
    if (!passCustomChecks) {
      return false;
    }

    if (!appearsAfterField && !backendFieldValidation) {
      return true;
    }
    let result = true;
    let i = 0;
    /**
     * Corporate - Standard Pricing must follow the Business Regular Medium
     * flow. When evaluating any `appearsAfter` rule that depends on
     * iotAccountType, substitute Corporate -> BusinessRegularMedium so that
     * fields whose Contentful `appearsAfterValue` lists BRM (but not
     * Corporate) still appear for Standard-Pricing Corporate accounts.
     * Custom-Pricing Corporate (and legacy orders without iotCorporateType)
     * are unaffected and continue to use the existing Corporate flow.
     *
     * Exception: the iotCorporateType field itself depends on
     * iotAccountType === Corporate — it must stay visible whenever
     * Corporate is selected, regardless of which pricing option has been
     * picked. So we skip the substitution when evaluating this field's
     * own visibility.
     */
    const getEffectiveAccountTypeValue = (relatedFieldName, rawValue) => {
      if (relatedFieldName !== fieldIotAccountType) return rawValue;
      // The iotCorporateType field itself depends on Corporate — keep it
      // visible regardless of which pricing variant is selected.
      if (fieldName === fieldIotCorporateType) return rawValue;
      const corpType =
        getFieldValue(fieldIotCorporateType, fields) ||
        (orderData && orderData[fieldIotCorporateType]);
      return getEffectiveAccountType(rawValue, corpType, {
        valueCorporate,
        valueCorporateStandardPricing,
        valueBusinessRegularMedium
      });
    };
    if (appearsAfterField) {
      while (i < appearsAfterField.length && result) {
        const relatedFieldName = getFieldName(
          appearsAfterField[i],
          orderData,
          formName,
          yes
        );
        const relatedFieldType = getFieldType(relatedFieldName, fields);
        const relatedFieldValue =
          relatedFieldType === 'Checkbox'
            ? getFieldChecked(relatedFieldName, fields)
            : getFieldValue(relatedFieldName, fields);
        if (relatedFieldName) {
          if (
            fields[relatedFieldName] &&
            fields[relatedFieldName].isVisible &&
            relatedFieldValue
          ) {
            if (appearsAfterValue) {
              const effectiveValue = getEffectiveAccountTypeValue(
                relatedFieldName,
                relatedFieldValue
              );
              let isValueSelected;
              if (_.isArray(effectiveValue)) {
                isValueSelected = appearsAfterValue.find(item =>
                  effectiveValue.includes(item.fields.value)
                );
              } else {
                isValueSelected = appearsAfterValue.find(
                  item => effectiveValue === item.fields.value
                );
              }
              result = result && typeof isValueSelected !== 'undefined';
            }
          } else if (orderData && orderData[relatedFieldName]) {
            if (fields[relatedFieldName]) {
              if (
                (isFormTouched &&
                  orderData[relatedFieldName] === relatedFieldValue) ||
                !isFormTouched
              ) {
                if (appearsAfterValue) {
                  const effectiveValue = getEffectiveAccountTypeValue(
                    relatedFieldName,
                    orderData[relatedFieldName]
                  );
                  const isValueSelected = appearsAfterValue.find(
                    item => effectiveValue === item.fields.value
                  );
                  result = result && typeof isValueSelected !== 'undefined';
                }
              } else result = false;
            } else if (appearsAfterValue) {
              const effectiveValue = getEffectiveAccountTypeValue(
                relatedFieldName,
                orderData[relatedFieldName]
              );
              const isValueSelected = appearsAfterValue.find(
                item => effectiveValue === item.fields.value
              );
              result = result && typeof isValueSelected !== 'undefined';
            }
          } else {
            result = false;
          }
        }
        i += 1;
      }
    }

    if (backendFieldValidation) {
      let isVisible = result;
      for (let index = 0; index < backendFieldValidation.length; index += 1) {
        const {
          fields: { key, value }
        } = backendFieldValidation[index];
        isVisible =
          isVisible &&
          (value.split('|').includes(orderData[key]) ||
            (value.split('|').includes('undefined') &&
              typeof orderData[key] === 'undefined'));
      }
      return isVisible;
    }

    return result;
  };

  const getHiddenSections = fields => {
    const hiddenSections = [];

    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (!isRelatedFieldExisted(section.fields, fields)) {
        hiddenSections.push(sectionName);
      }
    });

    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  const isDeliverySectionAvailable = () => {
    let isHardwareSelected = false;
    Object.keys(ratePlans).forEach(plan => {
      Object.keys(_.get(ratePlans, plan, {})).forEach(device => {
        const deviceDetails = _.get(ratePlans, `${plan}.${device}`, '');
        if (
          [value2year, value3year].includes(deviceDetails.term) &&
          deviceDetails.quantity > 0
        )
          isHardwareSelected = true;
      });
    });
    if (!isHardwareSelected) {
      const totalHardwareQuantity = Object.keys(hardware).reduce(
        (acc, device) => {
          return acc + hardware[device].additionalQuantity;
        },
        0
      );
      isHardwareSelected = totalHardwareQuantity > 0;
    }
    return (
      isHardwareSelected ||
      [
        valueNorthStarSystems,
        valueNorthStarSystemsFarmAndRanch,
        valueFillipFleet,
        valueGeotab
      ].includes(valueProductSelected)
    );
  };

  const sectionIsVisible = name => {
    if (name === 'iotDeliveryDetails') return isDeliverySectionAvailable();
    if (['iotVehicleInfo', 'iotTankDetails'].includes(name))
      return Boolean(viewType);
    if (name === 'iotSummary') {
      if (
        valueProductSelected === valueNorthStarSystems &&
        viewType === 'advancedView'
      )
        return false;
    }

    return (
      typeof sections.find(item => item.fields.name === name) !== 'undefined'
    );
  };
  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required
    );
    const filteredData = formValues.filter(formValue => {
      const filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }) => !formValue[formKeyValue]
      );
      return filteredValues.length > 0;
    });
    return filteredData;
  };

  const msgMinValue = value => stringInterpolation(minValueErrorMessage, value);
  const msgMaxValue = value => stringInterpolation(maxValueErrorMessage, value);
  const msgMinLength = value =>
    stringInterpolation(minLengthErrorMessage, value);
  const msgMaxLength = value =>
    stringInterpolation(maxLengthErrorMessage, value);

  const isOneDeviceSelected = deviceList => {
    return Object.keys(deviceList).some(deviceName => {
      const { quantity, term } = deviceList[deviceName];
      return term && quantity;
    });
  };

  const validateRatePlanList = () => {
    return Object.keys(ratePlans).every(planName => {
      const allDevicesSelectionValid = Object.keys(ratePlans[planName]).every(
        deviceName => {
          const { fiftyPercentInUS, quantity, term } = ratePlans[planName][
            deviceName
          ];
          const oneDeviceSelected = fiftyPercentInUS
            ? isOneDeviceSelected(ratePlans[planName])
            : false;
          let allConditionsValid = true;
          if (fiftyPercentInUS && !oneDeviceSelected && !term)
            allConditionsValid = false;
          if (term && !quantity) allConditionsValid = false;

          return allConditionsValid;
        }
      );
      return allDevicesSelectionValid;
    });
  };

  const getErrors = (data, errors) => {
    let result = errors;
    if (!data) return result;
    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { ineligible } = fields;
      const key = fields.name;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength,
        type,
        checked
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];

      /** Delete key if it exists because of an earlier error */
      if (key in result) delete result[key];

      if (id === formFieldsGroup && isRelatedFieldExisted(fields, formFields)) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired && type !== 'Checkbox') {
          if (!value && isRelatedFieldExisted(fields, formFields)) {
            result[key] = { text: fieldRequiredMessage, ref };
          } else {
            delete result[key];
          }
        }
        if (ineligible) {
          const {
            fields: { value: ineligibleValue }
          } = ineligible;
          const isIneligibleValue = ineligibleValue.split('|').includes(value);
          if (isIneligibleValue) {
            result[key] = { text: cannotProceedMessage, ref };
          }
        }
        if (isRequired && type === 'Checkbox') {
          if (!checked && isRelatedFieldExisted(fields, formFields))
            result[key] = { text: fieldRequiredMessage, ref };
          else delete result[key];
        }

        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = { text: msgMinValue(minValue), ref };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = { text: msgMaxValue(maxValue), ref };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = { text: msgMinLength(minLength), ref };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = { text: msgMaxLength(maxLength), ref };
        }

        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(fields, formFields))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = +value < +expectedValue;
                break;
              default:
            }
            if (hasError) result[key] = { text: errorMessage, ref };
          }
        }
      }

      /** View Type validation */
      if (key === 'viewToggleButtons' && !viewType)
        result[key] = { text: errorMessageViewType, ref };

      /** Rate plan validation */
      if (key === 'iotRatePlans') {
        if (!validateRatePlanList())
          result[key] = {
            text: errorMessageRatePlan,
            ref
          };
      }

      /** Rate plan Renewal validation */
      if (key === 'iotRatePlansRenewal') {
        const valueSubscriberRenewalOption = getFieldValue(
          fieldIotSubscribersRenewalOptions,
          formFields
        );

        if (
          valueSubscriberRenewalOption === valueEnterListManually &&
          renewalSubscriberList.length === 0
        )
          result[key] = {
            text: errorMessageRenewal,
            ref
          };
      }
      /** Tank Details validation */
      if (key === 'iotTankDetailsManually') {
        const valueTankDetailsOption = getFieldValue(
          'iotTankDetailsOption',
          formFields
        );

        if (
          valueTankDetailsOption === valueEnterTankDetailsManually &&
          tankDetails.length === 0
        )
          result[key] = {
            text: errorMessageTankDetails,
            ref
          };
      }

      /** Technical Services validation */
      if (key === 'iotTechnicalServices') {
        if (viewType === 'advancedView' && total.technicalServices === 0)
          result[key] = {
            text: errorMessageTechnicalServices,
            ref
          };
        else delete result[key];
      }
      /** Accessory selection validation for Fleetcomplete */
      if (
        key === 'iotHardware' &&
        [valueFleetcomplete].includes(valueProductSelected)
      ) {
        const totalAccessoriesSelected = Object.entries(hardware).reduce(
          (acc, [, hardwareDataObj]) => {
            const { isAccessory, additionalQuantity } = hardwareDataObj;
            if (isAccessory) return acc + +additionalQuantity;
            return acc;
          },
          0
        );
        if (totalAccessoriesSelected === 0)
          result[key] = {
            text: 'Please select an accessory',
            ref
          };
        else delete result[key];
      }

      if (key === 'monthlySoftwarePricing') {
        const isMonthlySoftwareSubscriptionQuantityExceeded = Object.entries(
          monthlySoftwareSubscription
        ).some(([, ratePlanDataObj]) => {
          const { additionalQuantity } = ratePlanDataObj;
          return additionalQuantity > 999;
        });
        if (isMonthlySoftwareSubscriptionQuantityExceeded) {
          result[key] = {
            text: 'The quantity cannot be greater than 999.',
            ref
          };
        } else {
          delete result[key];
        }
      }

      if (key === 'hardwarePowerFleet') {
        const isHardwarePowerFleetQuantityExceeded = Object.entries(
          hardwarePowerFleet
        ).some(([, ratePlanDataObj]) => {
          const { additionalQuantity } = ratePlanDataObj;
          return additionalQuantity > 999;
        });
        if (isHardwarePowerFleetQuantityExceeded) {
          result[key] = {
            text: 'The quantity cannot be greater than 999.',
            ref
          };
        } else {
          delete result[key];
        }
      }

      if (key === 'professionalServices') {
        const isProfessionalServicesQuantityExceeded = Object.entries(
          professionalServices
        )
          .filter(
            ([keyName, service]) =>
              service.additionalQuantity >
              unitLimitForprofessionalServices[keyName]
          )
          .map(
            ([keyName]) =>
              `${keyName} - The quantity cannot be greater than ${unitLimitForprofessionalServices[keyName]}.`
          );

        if (isProfessionalServicesQuantityExceeded.length > 0) {
          result[key] = {
            text: isProfessionalServicesQuantityExceeded,
            ref
          };
        } else {
          delete result[key];
        }
      }

      if (key === 'hardwareColdChain') {
        const isHardwareColdChainQuantityExceeded = Object.entries(
          hardwareColdChainPowerFleet
        ).some(([, ratePlanDataObj]) => {
          const { additionalQuantity } = ratePlanDataObj;
          return additionalQuantity > 499;
        });
        if (isHardwareColdChainQuantityExceeded) {
          result[key] = {
            text: 'The quantity cannot be greater than 499.',
            ref
          };
        } else {
          delete result[key];
        }
      }

      if (key === 'professionalServicesColdChain') {
        const isProfessionalServicesQuantityExceeded = Object.entries(
          professionalServicesColdChain
        )
          .filter(
            ([keyName, service]) =>
              service.additionalQuantity >
              unitLimitForprofessionalServicesColdChain[keyName]
          )
          .map(
            ([keyName]) =>
              `${keyName} - The quantity cannot be greater than ${unitLimitForprofessionalServicesColdChain[keyName]}.`
          );

        if (isProfessionalServicesQuantityExceeded.length > 0) {
          result[key] = {
            text: isProfessionalServicesQuantityExceeded,
            ref
          };
        } else {
          delete result[key];
        }
      }

      // BYOD Validation - Ensure it's quantity not greater than 2000
      if (
        key === 'iotRatePlans' &&
        [valueFleetcomplete].includes(valueProductSelected)
      ) {
        const isByodQuantityExceeded = Object.entries(ratePlans).some(
          ([, ratePlanDataObj]) => {
            const { BYOD } = ratePlanDataObj;
            return BYOD && BYOD.quantity > 2000;
          }
        );

        if (isByodQuantityExceeded) {
          result[key] = {
            text: 'The quantity of BYOD cannot be greater than 2000.',
            ref
          };
        } else {
          delete result[key];
        }
      }
      // Validation for Fillip Fleet ID check **
      if (key === fieldIotFillipFleetIdCheck) {
        const valueIotFillipFleetIdCheck = getFieldValue(
          fieldIotFillipFleetIdCheck,
          formFields
        );
        if (valueIotFillipFleetIdCheck === no)
          result[key] = {
            text: 'The form is mandatory',
            ref
          };
        else delete result[key];
      }
    });

    return result;
  };

  const getServiceListData = serviceObj =>
    Object.entries(serviceObj).reduce((acc, [serviceKey, serviceData]) => {
      const { quantity, unitPrice, isThePriceForDueNow } = serviceData;
      if (quantity > 0)
        return [
          ...acc,
          {
            name: serviceKey,
            quantity,
            unitPrice,
            isThePriceForDueNow
          }
        ];
      return acc;
    }, []);

  // Same shape as `getServiceListData` plus a `term` field. Used for
  // bundle-style services (e.g. Geotab Bundles) where the row UI shows
  // a fixed contract term alongside name/quantity/unitPrice.
  const getBundleListData = (bundleObj, term) =>
    Object.entries(bundleObj).reduce((acc, [bundleKey, bundleData]) => {
      const { quantity, unitPrice, isThePriceForDueNow } = bundleData;
      if (quantity > 0)
        return [
          ...acc,
          {
            name: bundleKey,
            quantity,
            unitPrice,
            isThePriceForDueNow,
            term
          }
        ];
      return acc;
    }, []);

  const getFormData = () => {
    const result = Object.keys(formFields)
      .filter(key => typeof formFields[key].value !== 'undefined')
      .reduce((acc, key) => {
        const { type, value: oldValue, checked, isVisible } = formFields[key];
        const value = isVisible ? oldValue : '';
        acc[key] = type === 'Checkbox' ? checked : value;
        return acc;
      }, {});
    result.provinceOfTheOrder = _.get(result, 'iotProvince', '');
    result.viewType = viewType;
    result.ratePlan = ratePlans;
    const {
      fleetTrackingServices,
      assetTrackingServices,
      videoTelematicServices,
      tattleSystemServices,
      fiftyPercentInUSSelected
    } = getRateplanData(ratePlans);

    // Adding a new property if Access to Geotab dashboard is selected in UI
    if (valueProductSelected === valueRaven)
      result.ravenWithGeotabDashboardAccess = fiftyPercentInUSSelected;

    result.fleetTrackingServices = fleetTrackingServices;
    result.assetTrackingServices = assetTrackingServices;
    result.videoTelematicServices = videoTelematicServices;
    result.tattleSystemServices = tattleSystemServices;
    result.renewalSubscriberList = renewalSubscriberList;
    result.geotabBundles = geotabBundles;
    result.geotabBundlesList = getBundleListData(geotabBundles, '3 year');
    result.addons = addons;
    result.addonsServices = getServiceListData(addons);
    result.additonalServicesList = getServiceListData(additionalServices);

    result.additionalServices = additionalServices;
    result.hardware = hardware;
    result.monthlySoftwareSubscription = monthlySoftwareSubscription;
    result.hardwarePowerFleet = hardwarePowerFleet;
    result.professionalServices = professionalServices;
    result.hardwareColdChainPowerFleet = hardwareColdChainPowerFleet;
    result.professionalServicesColdChain = professionalServicesColdChain;
    const { hardwareList, accessoryList, ravenAccessoryList } = getHardwareData(
      hardware,
      valueProductSelected
    );

    result.hardwareList = hardwareList;
    result.accessoryList = accessoryList;
    result.monthlySoftwareSubscriptionList = getDataOfAccessories(
      monthlySoftwareSubscription
    );
    result.hardwarePowerFleetList = getDataOfAccessories(hardwarePowerFleet);
    result.professionalServicesList = getDataOfAccessories(
      professionalServices
    );
    result.hardwareColdChainPowerFleetList = getDataOfAccessories(
      hardwareColdChainPowerFleet
    );
    result.professionalServicesColdChainList = getDataOfAccessories(
      professionalServicesColdChain
    );
    result.ravenAccessoryList = ravenAccessoryList;
    result.installServices = installServices;
    result.orderNow = orderNow;
    result.orderNowList = getServiceListData(orderNow);
    result.installServicesList = getServiceListData(installServices);
    result.technicalServices = technicalServices;
    result.technicalServicesList = getTechnicalServicesData(technicalServices);
    result.vehicleInfo = vehicleInfo;
    result.tankDetails = tankDetails;
    result.tankDetailsFarmAndRanch = tankDetailsFarmAndRanch;
    result.farmAndRanchTankDetails = getFarmAndRanchTankDetails(
      tankDetailsFarmAndRanch
    );
    result.total = total;
    // Aggregate the completed products from every IoTPopupButton field into a
    // single fixed key so the order summary can render them (see
    // `iotSummaryPhillipsConnectAssetTracker` in formSummaryGroup).
    result.iotPopupProducts = Object.values(formFields).reduce((acc, field) => {
      if (_.get(field, 'type') === 'IoTPopupButton') {
        const products = _.get(field, 'value.products', []);
        if (Array.isArray(products)) return [...acc, ...products];
      }
      return acc;
    }, []);
    return result;
  };

  const saveAndExit = () => {
    const fields = getFormData();
    if (Object.entries(fields).length) {
      onSaveAndExit(fields);
    }
  };

  const onOrderSubmit = e => {
    if (isSubmitting) return;
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      setIsSubmitting(true);
      try {
        const fields = getFormData();
        onFormSubmit({ ...fields });
      } finally {
        setTimeout(() => setIsSubmitting(false), 2000);
      }
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const resetFormFields = (fields, currentFieldName) => {
    const { resetFields, customResetFields } = fields[currentFieldName];
    let isResetRequired = false;
    const newFields = { ...fields };
    for (let index = 0; index < formStepFields.length; index += 1) {
      const {
        fields: { name, appearsAfterField, value }
      } = formStepFields[index];
      if (name === currentFieldName) {
        isResetRequired = true;
      } else if (isResetRequired) {
        const field = fields[name];
        if (appearsAfterField && field && field.isVisible) {
          const stillVisible = isRelatedFieldExisted(
            formStepFields[index].fields,
            newFields
          );
          if (!stillVisible)
            newFields[name] = { ...field, isVisible: false, value };
        }
      }
    }
    if (resetFields) {
      resetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.name', '');
        if (fieldName && _.has(newFields[fieldName], 'value'))
          newFields[fieldName].value = '';
      });
    }
    if (customResetFields) {
      customResetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.key', '');
        if (fieldName && _.has(newFields[fieldName], 'value'))
          newFields[fieldName].value = '';
        else delete newFields[fieldName];
      });
    }
    return newFields;
  };

  const isFieldCalculated = (type, value, checked, price) => {
    switch (type) {
      case 'Radio':
        return value === yes && price;
      case 'Checkbox':
        return checked && price;
      default:
        return value && price;
    }
  };

  const updateTotals = (name, field) => {
    const { value, type, price, monthlyPayment, isVisible } = field;
    if (!isVisible) return;

    let oldQuantity;
    let newQuantity;
    let oldPrice;
    let newPrice;

    if (type === 'Number') {
      oldQuantity = (formFields[name] && formFields[name].value) || 0;
      newQuantity = value ? Number(value) : 0;
      if (price > 0) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment > 0) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    }
  };

  const resetSelectedFields = (fields, isCustom = false) => {
    if (fields.length > 0) {
      const updatedOrderData = { ...orderData };
      fields.forEach(field => {
        const keyPath = isCustom ? 'fields.key' : 'fields.name';
        const fieldName = _.get(field, keyPath, '');
        if (_.has(orderData, fieldName)) {
          updatedOrderData[fieldName] = '';
        }
      });
      setIsFieldReset(true);
      setOrderData(updatedOrderData);
    }
  };

  const checkPrequalEligibility = () => {
    let isEligible = true;
    Object.keys(formFields).forEach(key => {
      const field = _.get(formStepFields, '0.fields.formFields', []).filter(
        item => item.fields.name === key
      );
      if (
        isRelatedFieldExisted(_.get(field, '0.fields', {}), formFields) &&
        !formFields[key].value
      )
        isEligible = false;
    });
    setPrequalEligibility(isEligible);
  };

  const getTotalUnitsSelected = () => {
    const totalIncludedHardware = Object.keys(ratePlans).reduce(
      (acc, current) => {
        const ratePlanTotal = Object.keys(ratePlans[current]).reduce(
          (rateplanAcc, item) => {
            const { quantity, term } = ratePlans[current][item];
            if ([value2year, value3year].includes(term) && quantity)
              return rateplanAcc + +quantity;
            return rateplanAcc;
          },
          0
        );
        return acc + ratePlanTotal;
      },
      0
    );

    const totalAdditionalHardwareAndAccessories = Object.keys(hardware).reduce(
      (acc, device) => {
        return acc + hardware[device].additionalQuantity;
      },
      0
    );
    return totalIncludedHardware + totalAdditionalHardwareAndAccessories;
  };

  const getShippingRates = (fixed = false) => {
    let standardShippingRate = 0;
    let expeditedShippingRate = 0;
    if (fixed) {
      standardShippingRate = 35;
      expeditedShippingRate = 125;
      return {
        standardShippingRate,
        expeditedShippingRate
      };
    }
    const totalUnits = getTotalUnitsSelected();

    if (totalUnits === 1) {
      standardShippingRate = 40;
      expeditedShippingRate = 95;
    } else if (totalUnits >= 2 && totalUnits <= 5) {
      standardShippingRate = 50;
      expeditedShippingRate = 125;
    } else if (totalUnits >= 6 && totalUnits <= 10) {
      standardShippingRate = 60;
      expeditedShippingRate = 165;
    } else if (totalUnits >= 11 && totalUnits <= 25) {
      standardShippingRate = 75;
      expeditedShippingRate = 195;
    } else if (totalUnits >= 26 && totalUnits <= 40) {
      standardShippingRate = 90;
      expeditedShippingRate = 230;
    } else if (totalUnits >= 41 && totalUnits <= 50) {
      standardShippingRate = 110;
      expeditedShippingRate = 265;
    } else if (totalUnits >= 51 && totalUnits <= 100) {
      standardShippingRate = 225;
      expeditedShippingRate = 450;
    } else if (totalUnits >= 101 && totalUnits <= 150) {
      standardShippingRate = 350;
      expeditedShippingRate = 700;
    } else if (totalUnits >= 151 && totalUnits <= 499) {
      standardShippingRate = 1050;
      expeditedShippingRate = 2250;
    } else if (totalUnits >= 500) {
      standardShippingRate = 2250;
      expeditedShippingRate = 4500;
    }
    return {
      standardShippingRate,
      expeditedShippingRate
    };
  };

  const handleFormField = (
    { name, value, checked },
    isFieldModified,
    fileUploded
  ) => {
    const fields = { ...formFields };
    let needToCheck = 1;
    const addAmountToNow = 0;
    const addAmountToMonthly = 0;
    let subtractAmountFromNow = 0;
    let subtractAmountFromMonthly = 0;

    setIsFieldReset(false);
    setIsFormValidated(false);

    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
    }

    fields[name] = {
      ...fields[name],
      value,
      checked,
      isVisible: true,
      touched: true
    };

    if (fields[name].type === 'MultiCheckbox') {
      fields[name].options = getMultiCheckboxOptions(
        fields[name].options,
        value,
        name,
        fields,
        orderData
      );
    }

    if (fields[name].type === 'MultiFileUpload') {
      fields[name] = { ...fields[name], fileUploded };
      formFields[name] = { ...formFields[name], fileUploded };
      formStepFields[name] = { ...formStepFields[name], fileUploded };
    }

    updateTotals(name, fields[name]);
    if (['Select', 'Radio'].includes(fields[name].type)) {
      const currentField = findField(formStepFields, name);
      if (currentField && currentField.fields && currentField.fields.options) {
        const currentOption = currentField.fields.options.find(
          item => item.fields.value === value
        );

        if (typeof currentOption !== 'undefined') {
          fields[name].price = currentOption.fields.price || 0;
          fields[name].monthlyPayment =
            currentOption.fields.monthlyPayment || 0;
        } else {
          if (fields[name].price) fields[name].price = 0;
          if (fields[name].monthlyPayment) fields[name].monthlyPayment = 0;
        }
      }
    }

    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));

    const getDisabledFields = (data, initFields) => {
      let result = initFields;

      const filter = !data
        ? []
        : data.filter(item => {
            const { sys, fields: itemFields } = item;
            const {
              name: itemName,
              appearsAfterField,
              eligible: eligibleField,
              ineligible,
              ineligibleNote
            } = itemFields;
            const {
              contentType: {
                sys: { id }
              }
            } = sys;
            if (name === itemName) {
              if (eligibleField) {
                const {
                  fields: { value: eligibleValue }
                } = eligibleField;
                setEligible({
                  isEligible:
                    eligibleValue === value ||
                    (eligibleValue === requiredValue && !!value && value !== 0),
                  note: {}
                });
              } else if (ineligible) {
                const {
                  fields: { value: ineligibleValue }
                } = ineligible;
                const isIneligibleValue = ineligibleValue
                  .split('|')
                  .includes(value);
                setEligible({
                  isEligible: false,
                  note: isIneligibleValue ? ineligibleNote : {}
                });
              }
            }
            if (id === formFieldsGroup) {
              result = getDisabledFields(itemFields.fields, result);
            } else if (id === formSection) {
              result = getDisabledFields(itemFields.formFields, result);
            } else if (fields[itemName] && appearsAfterField) {
              const isVisible = isRelatedFieldExisted(item.fields, fields);
              if (fields[itemName].isVisible) {
                fields[itemName].isVisible = isVisible;
                return !isVisible;
              }
              fields[itemName].isVisible = isVisible;
            }
            return false;
          });

      return [...result, ...filter];
    };

    while (needToCheck > 0 && needToCheck < 5) {
      const disabledFields = getDisabledFields(formStepFields, []);

      // eslint-disable-next-line no-loop-func
      disabledFields.forEach(item => {
        const {
          fields: { name: itemName }
        } = item;

        if (
          isFieldCalculated(
            fields[itemName].type,
            fields[itemName].value,
            fields[itemName].checked,
            fields[itemName].price
          )
        ) {
          const itemPrice =
            fields[itemName].type === 'Number'
              ? Number(fields[itemName].initPrice) *
                Number(fields[itemName].value)
              : Number(fields[itemName].price);
          subtractAmountFromNow += itemPrice;
        }

        if (
          isFieldCalculated(
            fields[itemName].type,
            fields[itemName].value,
            fields[itemName].checked,
            fields[itemName].monthlyPayment
          )
        ) {
          const itemPrice =
            fields[itemName].type === 'Number'
              ? Number(fields[itemName].initMonthlyPayment) *
                Number(fields[itemName].value)
              : Number(fields[itemName].monthlyPayment);
          subtractAmountFromMonthly += itemPrice;
        }
      });

      needToCheck = disabledFields.length > 0 ? needToCheck + 1 : 0;
    }

    if (addAmountToNow || subtractAmountFromNow) {
      setDueNow(dueNow - subtractAmountFromNow + addAmountToNow);
    }
    if (addAmountToMonthly || subtractAmountFromMonthly) {
      setDueMonthly(
        dueMonthly - subtractAmountFromMonthly + addAmountToMonthly
      );
    }

    // Logic to reset RATE PLANS when account type is changed. Just for Raven
    if (name === fieldIotAccountType && valueProductSelected === valueRaven) {
      setRatePlans({});
    }

    if (
      name === fieldIotDeliveryOptions &&
      valueProductSelected === valueFleetcomplete
    ) {
      const { standardShippingRate, expeditedShippingRate } = getShippingRates(
        true
      );
      if (value === valueStandardShipping) {
        setTotal(previousVal => ({
          ...previousVal,
          shippingCharges: standardShippingRate
        }));
      }
      if (value === valueExpeditedShipping) {
        setTotal(previousVal => ({
          ...previousVal,
          shippingCharges: expeditedShippingRate
        }));
      }
    }

    /**
     * Use a functional setState so the corporate radio chain
     * (iotAccountType + iotCorporateType) is always read from the
     * LATEST state instead of the closure snapshot that
     * `handleFormField` was created with.
     *
     * This guards specifically against async stale-closure callers —
     * e.g. FieldMultiFileUpload's `useEffect` HTTP fetch resolving
     * AFTER the user has already toggled Standard <-> Custom and
     * firing `onChange('')` with a stale `formFields` reference, which
     * would otherwise clobber the freshly-selected pricing option.
     */
    setFormFields(prev => {
      const next = resetFormFields(fields, name);
      if (
        name !== fieldIotAccountType &&
        prev &&
        prev[fieldIotAccountType] &&
        next[fieldIotAccountType]
      ) {
        next[fieldIotAccountType] = {
          ...next[fieldIotAccountType],
          value: prev[fieldIotAccountType].value
        };
      }
      if (
        name !== fieldIotCorporateType &&
        prev &&
        prev[fieldIotCorporateType] &&
        next[fieldIotCorporateType]
      ) {
        next[fieldIotCorporateType] = {
          ...next[fieldIotCorporateType],
          value: prev[fieldIotCorporateType].value
        };
      }
      return next;
    });

    if (_.has(fields, `${name}.resetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.resetFields`, []));
    } else if (_.has(fields, `${name}.customResetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.customResetFields`, []), true);
    }
  };

  const renderFormSummary = (formSummaryGroup, data = orderData) => {
    let summaryData = data;
    summaryData = { ...profile, ...summaryData };
    return <FormSummaryGroup data={formSummaryGroup} orderData={summaryData} />;
  };

  const getAccountType = options => {
    if (
      [
        valueGeotab,
        valueFleetcomplete,
        valueNorthStarSystems,
        valueFillipFleet,
        valuePowerFleet,
        valueGeoforce
      ].includes(valueProductSelected)
    ) {
      const updatedOptions = options.filter(option =>
        [valueBusinessRegularMedium, valueCorporate].includes(
          option.fields.value
        )
      );
      return updatedOptions;
    }
    if (valueProductSelected === valueRaven) {
      const updatedOptions = options.filter(
        option => ![valueBusinessRegularSmall].includes(option.fields.value)
      );
      return updatedOptions;
    }

    if (valueProductSelected === valueNorthStarSystemsFarmAndRanch) {
      const updatedOptions = options.filter(
        option => option.fields.value === valueBusinessRegularSmall
      );
      return updatedOptions;
    }
    return options;
  };

  const renderFormFields = data =>
    data &&
    data.map(({ sys, fields }, index) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const { name: fieldName, title, expiredDate, type, note2 } = fields;
      const fieldValue = getFieldValue(fieldName, formFields);
      const fieldDateConfig = {};
      let selectOptions = _.get(fields, 'options', []);
      const isRequired = fields.required || false;
      const fieldNote = fields.note;
      const fieldNote2 = note2;
      const valueRenewalorActivation = _.get(
        orderData,
        fieldIotActivationOrRenwal,
        ''
      );

      if (isChannelFleetCompleteCompatible) {
        if (fieldName === fieldIotProductSelected) {
          const allowedOption = [valueFleetcomplete, valuePowerFleet];
          selectOptions = fields.options.filter(item =>
            allowedOption.includes(item.fields.value)
          );
        }
      }

      const filterRateplanList = (rateplanContentful, isActivation) => {
        // Didn't have enough content model so added rateplans for Fillip fleet to Farm and ranch model
        if (valueProductSelected === valueFillipFleet) {
          return rateplanContentful.rateplanListFillipFleet;
        }

        if (isActivation === 'Activation' && rateplanContentful) {
          // BYOD is only offered on the GO Core rate plan
          return showByodOnActivation(rateplanContentful.rateplanList, [
            'Go Core'
          ]);
        }

        if (rateplanContentful) {
          return rateplanContentful.rateplanList;
        }

        return [];
      };

      if (type === 'MultiCheckbox') {
        selectOptions = formFields[fieldName].options;
      }

      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${index}${sysId}`;
      let result;

      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields)) return null;

      if (fieldName === fieldIotAccountType)
        selectOptions = [...getAccountType(selectOptions)];

      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(itemFields, formFields)
          );
        });

        if (typeof groupIsVisible !== 'undefined') {
          const groupFields = renderFormFields(fields.fields);
          if (fieldName === 'advisory') {
            result = groupFields.filter(item => item).length > 0 && (
              <GroupWrapperStyled key={key}>{groupFields}</GroupWrapperStyled>
            );
          } else {
            result = groupFields.filter(item => item).length > 0 && (
              <GroupWrapper key={key}>
                {title && <GroupTitle>{title}</GroupTitle>}
                {groupFields}
              </GroupWrapper>
            );
          }
        }
      } else if (id === formSection) {
        const { note, formSummaryGroup, isPanelInitiallyOpen } = fields;
        result = sectionIsVisible(fieldName) && (
          <ExpandCollapse
            initialOpen={isPanelInitiallyOpen ? [fieldName] : []}
            topDivider={false}
          >
            {(expandProps) => (
              <ExpandCollapse.Panel {...expandProps} key={key} panelId={fieldName} control={<SectionHeaderTitle><Typography variant={{ bold: true }}>{title}</Typography></SectionHeaderTitle>}>
                <>
                  <Divider space={1} variant={{ inverse: true }} />
                  {note && note.content && <Note data={note} type="richText" />}
                  {formSummaryGroup
                    ? renderFormSummary(formSummaryGroup)
                    : renderFormFields(fields.formFields)}
                </>
              </ExpandCollapse.Panel>
            )}
          </ExpandCollapse>
        );
      } else if (id === userDetailsKey) {
        const { backendKey } = fields;

        result =
          backendKey === 'shippingAddress' ? null : (
            <UserDetailsForm
              key={key}
              data={fields}
              formName={formName}
              setFormFields={setFormFields}
              orderData={orderData}
              formErrors={formErrors}
              formFields={formFields}
              isFormTouched={isFormTouched}
              setIsFormTouched={setIsFormTouched}
              resetSelectedFields={resetSelectedFields}
            />
          );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            isMultisiteOrder={false}
          />
        );
      } else if (fields.type === 'IoTViewToggle') {
        result = (
          <ViewsToggle
            productSelected={valueProductSelected}
            viewType={viewType}
            setViewType={setViewType}
            formErrors={formErrors}
          />
        );
      } else if (fields.type === 'IoTRateplans') {
        result = contentfulData &&
          viewType &&
          (![valueNorthStarSystems, valueNorthStarSystemsFarmAndRanch].includes(
            valueProductSelected
          ) ||
            ([
              valueNorthStarSystems,
              valueNorthStarSystemsFarmAndRanch
            ].includes(valueProductSelected) &&
              viewType === 'simpleView')) && (
            <>
              <Divider space={1} variant={{ inverse: true }} />
              <RatePlans
                orderType={_.get(orderData, fieldIotActivationOrRenwal, '')}
                hardware={hardware}
                productSelected={valueProductSelected}
                rateplanList={filterRateplanList(
                  contentfulData,
                  valueRenewalorActivation
                )}
                contentfulError={contentfulError}
                accountType={getFieldValue(fieldIotAccountType, formFields)}
                corporateType={getFieldValue(fieldIotCorporateType, formFields)}
                viewType={viewType}
                ratePlans={ratePlans}
                setRatePlans={setRatePlans}
                total={total.ratePlan}
                setTotal={setTotal}
                formErrors={formErrors}
                setGeoTabNewPriceValid={setGeoTabNewPriceValid}
                setHardware={setHardware}
              />
            </>
          );
      } else if (fields.type === 'IoTRateplansRenewal') {
        result = contentfulData && viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <RatePlansRenewal
              isCorporate={checkCustomPricingCorporate(
                getFieldValue(fieldIotAccountType, formFields),
                getFieldValue(fieldIotCorporateType, formFields),
                { valueCorporate, valueCorporateStandardPricing }
              )}
              rateplanList={contentfulData.rateplanList}
              contentfulError={contentfulError}
              renewalSubscriberList={renewalSubscriberList}
              setRenewalSubscriberList={setRenewalSubscriberList}
              setTotal={setTotal}
              formErrors={formErrors}
            />
          </>
        );
      } else if (fields.type === 'IoTGeotabBundles') {
        if (contentfulData) {
          // console.log('contentfulData', contentfulData);
          // console.log('geotabBundles', contentfulData.geotabBundles);
        }
        result = contentfulData && viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <GeotabBundles
              itemsList={contentfulData.geotabBundles || []}
              contentfulError={contentfulError}
              viewType={viewType}
              installServices={geotabBundles}
              setInstallServices={setGeotabBundles}
              total={total.geotabBundles}
              setTotal={setTotal}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTAddons') {
        const valueOrderType = _.get(orderData, fieldIotActivationOrRenwal, '');
        result = contentfulData &&
          viewType &&
          (viewType === 'advancedView' ||
            valueProductSelected === valueGeotab ||
            (valueProductSelected === valueFleetcomplete &&
              valueOrderType === valueRenewal)) && (
            <>
              <Divider space={1} variant={{ inverse: true }} />
              <Addons
                addonsList={contentfulData.addonsList || []}
                contentfulError={contentfulError}
                viewType={viewType}
                addons={addons}
                setAddons={setAddons}
                total={total.addons}
                setTotal={setTotal}
              />
              <Divider space={1} variant={{ inverse: true }} />
            </>
          );
      } else if (fields.type === 'IoTOrderNow') {
        result = contentfulData && viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <OrderNow
              orderNowList={contentfulData.orderNowList || []}
              contentfulError={contentfulError}
              viewType={viewType}
              installServices={orderNow}
              setInstallServices={setOrderNow}
              total={total.orderNow}
              setTotal={setTotal}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTAdditionalServices') {
        result = contentfulData && viewType && viewType === 'advancedView' && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <AdditionalServices
              additionalServicesList={
                contentfulData.additionalServicesList || []
              }
              contentfulError={contentfulError}
              viewType={viewType}
              additionalServices={additionalServices}
              setAdditionalServices={setAdditionalServices}
              total={total.additionalServices}
              setTotal={setTotal}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTInstallServices') {
        result = contentfulData && viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <InstallServices
              installServicesList={contentfulData.installServicesList}
              contentfulError={contentfulError}
              viewType={viewType}
              installServices={installServices}
              setInstallServices={setInstallServices}
              total={total.installServices}
              setTotal={setTotal}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTHardware') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <Hardware
              productSelected={valueProductSelected}
              hardwareList={contentfulData.hardwareList}
              contentfulError={contentfulError}
              isRenewal={
                _.get(orderData, fieldIotActivationOrRenwal, '') ===
                  valueRenewal ||
                valueProductSelected === valueNorthStarSystemsFarmAndRanch
              }
              viewType={viewType}
              ratePlans={ratePlans}
              hardware={hardware}
              setHardware={setHardware}
              total={total}
              setTotal={setTotal}
              error={_.get(formErrors, 'iotHardware.text', '')}
              geoTabNewPriceValid={geoTabNewPriceValid}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTInstallationServices') {
        if (!contentfulData || !viewType) return null;
        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <InstallServicesGeotab
              installServicesList={contentfulData.installationServicesList}
              contentfulError={contentfulError}
              viewType={viewType}
              installServices={installServices}
              setInstallServices={setInstallServices}
              total={total.installServices}
              setTotal={setTotal}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTVehicleInfo') {
        result = viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <VehicleInfo
              vehicleInfo={vehicleInfo}
              setVehicleInfo={setVehicleInfo}
            />

            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTTankDetails') {
        result = viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <TankDetails
              tankDetails={tankDetails}
              setTankDetails={setTankDetails}
              error={_.get(formErrors, 'iotTankDetailsManually.text', '')}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTTankDetailsFarmAndRanch') {
        result = (
          <>
            <TankDetailsFarmAndRanch
              tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
              setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
              error={_.get(formErrors, 'iotTankDetailsManually.text', '')}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTSummaryTracker') {
        const iotPopupProducts = Object.values(formFields).reduce(
          (acc, field) => {
            if (_.get(field, 'type') === 'IoTPopupButton') {
              const products = _.get(field, 'value.products', []);
              if (Array.isArray(products)) return [...acc, ...products];
            }
            return acc;
          },
          []
        );
        result = contentfulData && (
          <SummaryTracker
            productSelected={valueProductSelected}
            rateplanList={contentfulData.rateplanList}
            hasAdditonalServices={_.get(
              contentfulData,
              'additionalServicesList',
              ''
            )}
            ratePlans={ratePlans}
            addons={addons}
            additionalServices={additionalServices}
            hardware={hardware}
            vehicleInfo={vehicleInfo}
            installServices={installServices}
            orderNow={orderNow}
            geotabBundles={geotabBundles}
            iotPopupProducts={iotPopupProducts}
          />
        );
      } else if (fields.type === 'IoTPowerFleetSummaryTracker') {
        result = contentfulData && (
          <SummaryTrackerPowerFleet
            rateplanList={contentfulData.monthlySubscriptionColdChain}
            ratePlans={ratePlans}
            hardwarePowerFleet={hardwarePowerFleet}
            monthlySoftwareSubscription={monthlySoftwareSubscription}
            professionalServices={professionalServices}
            hardwareColdChainPowerFleet={hardwareColdChainPowerFleet}
            professionalServicesColdChain={professionalServicesColdChain}
          />
        );
      } else if (fields.type === 'IoTDeliveryCharges') {
        result = contentfulData && viewType && viewType === 'simpleView' && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <DeliveryCharges
              ratePlans={ratePlans}
              productSelected={valueProductSelected}
            />
          </>
        );
      } else if (fields.type === 'IoTTechnicalServices') {
        result = contentfulData && viewType && (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <TechnicalServices
              productSelected={valueProductSelected}
              hardware={hardware}
              viewType={viewType}
              technicalServicesList={contentfulData.technicalServicesList || []}
              technicalServices={technicalServices}
              setTechnicalServices={setTechnicalServices}
              total={total}
              setTotal={setTotal}
              formErrors={formErrors}
              contentfulError={contentfulError}
            />
          </>
        );
      } else if (fields.type === 'IoTMonthlySoftwarePricing') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <HardwarePowerfleet
              hardwareList={contentfulData.monthlySoftwarePricing}
              contentfulError={contentfulError}
              viewType={viewType}
              ratePlans={ratePlans}
              hardware={monthlySoftwareSubscription}
              setHardware={setMonthlySoftwareSubscription}
              total={total}
              setTotal={setTotal}
              error={_.get(formErrors, 'monthlySoftwarePricing.text', '')}
              headerText="Monthly Software Subscription"
              fieldType={fields.type}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTHardwarePowerFleet') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <HardwarePowerfleet
              hardwareList={contentfulData.hardwarePowerfleet}
              contentfulError={contentfulError}
              viewType={viewType}
              ratePlans={ratePlans}
              hardware={hardwarePowerFleet}
              setHardware={setHardwarePowerFleet}
              total={total}
              setTotal={setTotal}
              error={_.get(formErrors, 'hardwarePowerFleet.text', '')}
              headerText="Hardware"
              fieldType={fields.type}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTProfessionalServices') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <HardwarePowerfleet
              hardwareList={contentfulData.professionalServices}
              contentfulError={contentfulError}
              viewType={viewType}
              ratePlans={ratePlans}
              hardware={professionalServices}
              setHardware={setProfessionalServices}
              total={total}
              setTotal={setTotal}
              error={_.get(formErrors, 'professionalServices.text', '')}
              headerText="Professional Services"
              fieldType={fields.type}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTMonthlySubscription') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <RatePlans
              orderType={_.get(orderData, fieldIotActivationOrRenwal, '')}
              hardware={hardware}
              productSelected={valueProductSelected}
              rateplanList={contentfulData.monthlySubscriptionColdChain}
              contentfulError={contentfulError}
              accountType={getFieldValue(fieldIotAccountType, formFields)}
              corporateType={getFieldValue(fieldIotCorporateType, formFields)}
              viewType={viewType}
              ratePlans={ratePlans}
              setRatePlans={setRatePlans}
              total={total.ratePlan}
              setTotal={setTotal}
              formErrors={formErrors}
              setGeoTabNewPriceValid={setGeoTabNewPriceValid}
              setHardware={setHardware}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTHardwareColdChain') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <HardwarePowerfleet
              hardwareList={contentfulData.hardwareColdChain}
              contentfulError={contentfulError}
              viewType={viewType}
              ratePlans={ratePlans}
              hardware={hardwareColdChainPowerFleet}
              setHardware={setHardwareColdChainPowerFleet}
              total={total}
              setTotal={setTotal}
              error={_.get(formErrors, 'hardwareColdChain.text', '')}
              headerText="Hardware"
              fieldType={fields.type}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else if (fields.type === 'IoTProfessionalServicesColdChain') {
        if (!contentfulData || !viewType) return null;

        result = (
          <>
            <Divider space={1} variant={{ inverse: true }} />
            <HardwarePowerfleet
              hardwareList={contentfulData.professionalServicesColdChain}
              contentfulError={contentfulError}
              viewType={viewType}
              ratePlans={ratePlans}
              hardware={professionalServicesColdChain}
              setHardware={setProfessionalServicesColdChain}
              total={total}
              setTotal={setTotal}
              error={_.get(
                formErrors,
                'professionalServicesColdChain.text',
                ''
              )}
              headerText="Professional Services"
              fieldType={fields.type}
            />
            <Divider space={1} variant={{ inverse: true }} />
          </>
        );
      } else {
        // View gating for the IoTPopupButton field: the field carries a `view`
        // array of `viewType` values (`simpleView`/`advancedView`). It renders
        // only once a view is selected; when a view is selected it shows if the
        // `view` list is empty/missing (all views) or includes the current view.
        if (fields.type === 'IoTPopupButton') {
          const popupConfig = _.get(fields, 'iotPopupTablesName', {});
          let viewList = [];
          if (Array.isArray(_.get(popupConfig, 'view'))) {
            viewList = popupConfig.view;
          } else if (Array.isArray(fields.view)) {
            viewList = fields.view;
          }
          const viewMatches =
            Boolean(viewType) &&
            (viewList.length === 0 || viewList.includes(viewType));
          if (!viewMatches) return null;
        }
        const fieldButtonProps =
          fields.type === 'Button'
            ? {
                modalForms,
                formFields,
                setFormFields,
                dueNow,
                setDueNow,
                dueMonthly,
                setDueMonthly,
                setIsFormTouched,
                setIsFormValidated
              }
            : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }

        const fieldData = {
          ...fields,
          options: selectOptions || fields.options,
          ...fieldButtonProps,
          ref,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          required: isRequired,
          note: fieldNote,
          note2: fieldNote2,
          sysId,
          onChange: (e, isFieldModified = true, fileUploded) =>
            handleFormField(e.target, isFieldModified, fileUploded),
          fieldDateConfig,
          formFields,
          setFormFields,
          setOrderData,
          resetSelectedFields,
          contentfulData,
          setTotal
        };

        if (fields.type === 'Checkbox') {
          fieldData.checked = formFields[fieldName].checked;
        }

        // Renewal orders suppress the popup's one-time hardware charges.
        if (fields.type === 'IoTPopupButton') {
          fieldData.isRenewal =
            _.get(orderData, fieldIotActivationOrRenwal, '') === valueRenewal;
        }

        if (
          fieldName === fieldCustomerMigrating &&
          valueProductSelected === valueFleetcomplete
        ) {
          fieldData.label = labelFieldCustomerMigrationFC;
        }

        /** Adding dynamic delivery changes based on number of units */
        if (
          fieldName === fieldIotDeliveryOptions &&
          valueProductSelected === valueFleetcomplete
        ) {
          const updatedOptions = fieldData.options.map(optionObj => {
            const {
              fields: { label, value }
            } = optionObj;
            const {
              standardShippingRate,
              expeditedShippingRate
            } = getShippingRates(true);
            let newLabel = label.split(' (')[0];
            let shippingCharge = 0;
            if (label.includes(valueStandardShipping)) {
              newLabel = `${newLabel} ($${standardShippingRate})`;
              shippingCharge = standardShippingRate;
            }
            if (label.includes(valueExpeditedShipping)) {
              newLabel = `${newLabel} ($${expeditedShippingRate})`;
              shippingCharge = expeditedShippingRate;
            }

            return {
              ...optionObj,
              fields: {
                label: newLabel,
                value: value.split(' (')[0],
                price: shippingCharge
              }
            };
          });

          fieldData.options = [...updatedOptions];
          const optionSelected =
            fieldData.value &&
            fieldData.options.filter(
              option => option.fields.value === fieldData.value
            )[0];
          if (optionSelected) {
            const {
              fields: { price }
            } = optionSelected;

            if (price !== total.shippingCharges)
              setTotal(previousValue => ({
                ...previousValue,
                shippingCharges: price
              }));
          }
          if (!isDeliverySectionAvailable()) fieldData.value = '';
        }

        result = (
          <FormField
            key={key}
            orderData={orderData}
            data={fieldData}
            error={error && error.text}
          />
        );
      }
      return result;
    });

  const getSummary = () => {
    if (formSummary) {
      const {
        fields: { formSummaryGroup }
      } = formSummary;

      return formSummaryGroup.map((summaryGroup, index) => {
        const {
          fields: { name, formFields: summaryGroupFields }
        } = summaryGroup;
        const key = `formSummaryGroup${index}`;

        return (
          <Fragment key={key}>
            <h1>{name}</h1>
            <SummaryGroupWrapper>
              {summaryGroupFields.map((summaryGroupField, idx) => {
                const {
                  fields: { name: fieldName, label: fieldLabel }
                } = summaryGroupField;
                const summaryGroupFieldKey = `summaryGroupField${idx}`;

                return (
                  <div key={summaryGroupFieldKey}>
                    <span style={{ fontWeight: '400' }}>{fieldLabel}</span>:{' '}
                    {formFields[fieldName].value}
                  </div>
                );
              })}
            </SummaryGroupWrapper>
          </Fragment>
        );
      });
    }

    return Object.keys(formFields).map((item, index) => {
      const key = `summary${index}`;

      return (
        formFields[item].isVisible && (
          <div key={key}>
            <span style={{ fontWeight: '400' }}>{item}</span>:{' '}
            {formFields[item].value}
          </div>
        )
      );
    });
  };

  const onCreateNewOrder = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const formData = getFormData();
      // DEBUG: verify what we send for geotab — remove once BE switches
      // to consume `geotabBundlesList` instead of raw `geotabBundles`.
      // eslint-disable-next-line no-console
      console.log(
        '[geotab debug] geotabBundles (raw):',
        formData.geotabBundles
      );
      // eslint-disable-next-line no-console
      console.log(
        '[geotab debug] geotabBundlesList (filtered):',
        formData.geotabBundlesList
      );
      createNewIotOrder(formData);
    } finally {
      setTimeout(() => setIsSubmitting(false), 2000);
    }
  };

  useEffect(() => {
    if (formStepFields && !isFieldReset) {
      if (formName === iotOrderForm && !_.get(orderData, 'id', '')) return;
      const updatedFields = normalizedFields(formStepFields, formFields);
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));

      if (orderData.viewType) setViewType(orderData.viewType);
      if (orderData.ratePlan) setRatePlans(orderData.ratePlan);
      if (orderData.renewalSubscriberList)
        setRenewalSubscriberList(orderData.renewalSubscriberList);
      if (orderData.geotabBundles) setGeotabBundles(orderData.geotabBundles);
      if (orderData.addons) setAddons(orderData.addons);
      if (orderData.additionalServices)
        setAdditionalServices(orderData.additionalServices);
      if (orderData.hardware) setHardware(orderData.hardware);
      if (orderData.monthlySoftwareSubscription)
        setMonthlySoftwareSubscription(orderData.monthlySoftwareSubscription);
      if (orderData.hardwarePowerFleet)
        setHardwarePowerFleet(orderData.hardwarePowerFleet);
      if (orderData.professionalServices)
        setProfessionalServices(orderData.professionalServices);
      if (orderData.professionalServicesColdChain)
        setProfessionalServicesColdChain(
          orderData.professionalServicesColdChain
        );
      if (orderData.hardwareColdChainPowerFleet)
        setHardwareColdChainPowerFleet(orderData.hardwareColdChainPowerFleet);
      if (orderData.technicalServices)
        setTechnicalServices(orderData.technicalServices);
      if (orderData.vehicleInfo) setVehicleInfo(orderData.vehicleInfo);
      if (orderData.tankDetails) setTankDetails(orderData.tankDetails);
      if (orderData.installServices)
        setInstallServices(orderData.installServices);
      if (orderData.orderNow) setOrderNow(orderData.orderNow);
      if (orderData.tankDetailsFarmAndRanch)
        setTankDetailsFarmAndRanch(orderData.tankDetailsFarmAndRanch);

      setIsLoading(false);
      setIsFormTouched(false);

      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData]);

  useEffect(() => {
    const iotPopupMonthly = Object.values(total.iotPopup || {}).reduce(
      (sum, entry) => sum + (_.get(entry, 'monthly', 0) || 0),
      0
    );
    const iotPopupOneTime = Object.values(total.iotPopup || {}).reduce(
      (sum, entry) => sum + (_.get(entry, 'oneTime', 0) || 0),
      0
    );
    setDueMonthly(
      total.ratePlan +
        total.subscriberList +
        total.geotabBundles +
        total.addonsMonthly +
        total.monthlySoftwareSubscription +
        total.orderNow +
        iotPopupMonthly
    );
    setDueNow(
      total.hardware +
        total.addonsDueNow +
        total.accessories +
        total.additionalServices +
        total.deliveryCharges +
        total.technicalServices +
        total.shippingCharges +
        total.installServices +
        total.hardwarePowerFleet +
        total.professionalServices +
        total.hardwareColdChainPowerFleet +
        total.professionalServicesColdChain +
        total.ratePlanOneTime +
        iotPopupOneTime
    );
  }, [total]);

  useEffect(() => {
    /**
     * This condition checks if viewType had a previous value
     * and that value was not null
     */

    if (viewTypeRef.current) {
      setRatePlans({});
      setAddons({});
      setAdditionalServices({});
      setHardware({});
      setVehicleInfo([]);
      setTankDetails([]);
      setRenewalSubscriberList([]);
      setTechnicalServices({});
      setInstallServices({});
      setTotal({
        ratePlan: 0,
        subscriberList: 0,
        additionalServices: 0,
        geotabBundles: 0,
        addons: 0,
        hardware: 0,
        accessories: 0,
        installServices: 0,
        deliveryCharges: 0,
        technicalServices: 0,
        shippingCharges: 0,
        monthlySoftwareSubscription: 0,
        hardwarePowerFleet: 0,
        professionalServices: 0,
        hardwareColdChainPowerFleet: 0,
        professionalServicesColdChain: 0,
        orderNow: 0,
        iotPopup: {}
      });
      // Clear any completed IoTPopupButton products so a view switch is a fresh
      // start (consistent with the sections reset above): empties the field's
      // persisted value/summary and its footer contribution.
      setFormFields(prev => {
        const next = { ...prev };
        Object.keys(next).forEach(fieldKey => {
          if (_.get(next[fieldKey], 'type') === 'IoTPopupButton') {
            next[fieldKey] = { ...next[fieldKey], value: '' };
          }
        });
        return next;
      });
    }
    viewTypeRef.current = viewType;
  }, [viewType]);

  useEffect(() => {
    setIsFormTouched(true);
  }, [ratePlans, hardware, vehicleInfo, technicalServices, tankDetails]);

  useEffect(() => {
    if (formName === iotPrequalificationForm) checkPrequalEligibility();
  }, [formFields]);

  useEffect(() => {
    const footer = document.getElementById('footer');
    const introduction = document.getElementById('introduction');
    if (footer) footer.style.display = 'none';
    if (introduction) introduction.style.marginBottom = '7rem';

    return () => {
      if (footer) footer.style.display = '';
      if (introduction) introduction.style.marginBottom = '0';
    };
  }, []);

  if (isLoading) return null;
  return (
    <div ref={formStepRef} style={{ width: '100%' }}>
      {formName === iotOrderForm && (
        <div style={{ marginBottom: '2rem' }}>
          <div id="title">
            <div id="title-wrapper">
              <div style={{ padding: '2rem 0 0 0' }}>
                <Typography heading="h2" variant={{ size: 'h2'}}>
                  {formStepName}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      )}
      <div style={{ backgroundColor: '#fff' }}>
        <form
          name={formStepName}
          onSubmit={e => e.preventDefault()}
          encType="multipart/form-data"
        >
          <Box
            style={{
              border: '1px solid #e3e3e3',
              boxShadow: '1px 1px 9px 4px #e3e3e3',
              padding: '2rem',
              marginBottom: '1rem'
            }}
          >
            {sections.length ? (
              <div className="expand">
                <ExpandCollapse initialOpen={[]} tag="h2" topDivider={false}>
                  {renderFormFields(formStepFields)}
                </ExpandCollapse>
              </div>
            ) : (
              <div style={{ width: '100%' }}>
                {formStepFields ? (
                  renderFormFields(formStepFields)
                ) : (
                  <>
                    <Typography heading="h3" variant={{ size: 'h3' }} block>Summary</Typography>
                    {getSummary()}
                  </>
                )}
              </div>
            )}
          </Box>
        </form>
      </div>
      {formName === iotPrequalificationForm && (
        <div
          className="container 85%"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <Button
            type="button"
            onPress={onCreateNewOrder}
            variant={{ priority: 'high' }}
            disabled={isSubmitting || !prequalEligibility}
            style={{ marginBottom: '1em' }}
          >
            {isSubmitting ? submittingButtonLabel : newOrderButtonLabel}
          </Button>
        </div>
      )}
      {formName === iotOrderForm && (
        <StatusBar
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          dueMonthly={dueMonthly}
          dueNow={dueNow}
          onSaveAndExit={saveAndExit}
          onSubmit={onOrderSubmit}
          formErrors={formErrors}
          hidePricing={checkCustomPricingCorporate(
            getFieldValue(fieldIotAccountType, formFields),
            getFieldValue(fieldIotCorporateType, formFields),
            { valueCorporate, valueCorporateStandardPricing }
          )}
        />
      )}
    </div>
  );
};

FormStepIoT.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      formSummary: PropTypes.shape({
        fields: PropTypes.shape({
          formSummaryGroup: PropTypes.arrayOf(PropTypes.shape({}))
        })
      }),
      formStepFields: PropTypes.arrayOf(
        PropTypes.shape({
          fields: PropTypes.shape({
            name: PropTypes.string,
            appearsAfterField: PropTypes.arrayOf(PropTypes.shape({})),
            value: PropTypes.string
          })
        })
      ),
      modalForms: PropTypes.shape({})
    }).isRequired
  }).isRequired,
  setEligible: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  orderData: PropTypes.objectOf(PropTypes.shape({})),
  setOrderData: PropTypes.func,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  createNewIotOrder: PropTypes.func.isRequired,
  onFormSubmit: PropTypes.func.isRequired
};

export default FormStepIoT;
